import { Capacitor } from '@capacitor/core';

// True when running inside the Play Store TWA, the iOS Capacitor wrapper or an
// installed PWA. Used to keep Stripe checkout web-only (store billing policies).
export const isInstalledApp = () => {
  try {
    if (Capacitor.isNativePlatform()) return true;
    if (typeof window === 'undefined') return false;
    return (
      window.matchMedia?.('(display-mode: standalone)').matches ||
      window.navigator.standalone === true ||
      document.referrer.startsWith('android-app://')
    );
  } catch {
    return false;
  }
};

export const MANAGE_PLAN_WEB_MSG = 'Las suscripciones se contratan y gestionan en tovias.app desde el navegador. Dentro de la app puedes usar tu plan con normalidad.';
